import { getTheme } from './getTheme';
import { jsx as _jsx } from "react/jsx-runtime";
export function withTheme(WrappedComponent) {
  const WithDefaultTheme = props => {
    const theme = getTheme({
      theme: props.theme
    });
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      theme: theme
    }));
  };
  WithDefaultTheme.displayName = `WithTheme(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithDefaultTheme;
}
export default withTheme;